import { NEW_ENDPOINTS } from '@constants'
import {
  IEmailTemplate,
  IEmailLog,
  IEmailLogWithRelations,
  ISendEmailRequest,
  IEmailTemplateCreateRequest,
  IEmailTemplateUpdateRequest,
  IEmailLogsFilters,
  ISingleDocument,
} from '@typings'
import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { BaseApi } from './_base.api'

export class EmailApi extends BaseApi {
  // Email Templates
  getTemplates = (params?: AxiosRequestConfig['params']) =>
    this.api.get(NEW_ENDPOINTS.EMAIL.TEMPLATES.LIST, params).then(res => res.data)

  getTemplate = (id: IEmailTemplate['id']) =>
    this.api.get<AxiosResponse<IEmailTemplate>>(NEW_ENDPOINTS.EMAIL.TEMPLATES.SINGLE(id)).then(res => res.data.data)

  createTemplate = (data: IEmailTemplateCreateRequest) =>
    this.api.post(NEW_ENDPOINTS.EMAIL.TEMPLATES.LIST, data).then(res => res.data.data)

  updateTemplate = (id: IEmailTemplate['id'], data: IEmailTemplateUpdateRequest) =>
    this.api.put(NEW_ENDPOINTS.EMAIL.TEMPLATES.SINGLE(id), data).then(res => res.data.data)

  deleteTemplate = (id: IEmailTemplate['id']) => this.api.delete(NEW_ENDPOINTS.EMAIL.TEMPLATES.SINGLE(id))

  getDefaultTemplate = (type: string) =>
    this.api.get(NEW_ENDPOINTS.EMAIL.TEMPLATES.DEFAULT(type)).then(res => res.data)

  // Email Logs
  getLogs = (params?: IEmailLogsFilters) =>
    this.api.get(NEW_ENDPOINTS.EMAIL.LOGS.LIST, { params }).then(res => res.data)

  getLog = (id: IEmailLog['id']) =>
    this.api.get<AxiosResponse<IEmailLogWithRelations>>(NEW_ENDPOINTS.EMAIL.LOGS.SINGLE(id)).then(res => res.data.data)

  // Send Email
  sendDocumentEmail = (documentId: ISingleDocument['id'], data: ISendEmailRequest) =>
    this.api.post(NEW_ENDPOINTS.EMAIL.SEND_DOCUMENT(documentId), data).then(res => res.data.data)
}
